import RdBudgetFormService from '../../../services/rdBudgetFormService';

export const createBudget = (
  organizationId: string,
  propertyId: string,
  rentForecastId: string,
  data: any,
) => {
  const rdBudgetFormService = new RdBudgetFormService();

  return rdBudgetFormService.createWizardRentForecast(
    organizationId,
    propertyId,
    rentForecastId,
    data,
  );
};
